import type { Schema } from '@w/schema'
import {
  createAuthClient as createBaseAuthClient,
  type AuthClientConfig,
  type UserWithSettings,
} from './auth-client'

export function createAuthBindings<
  Settings extends Record<string, unknown>,
>(config: { userSettingsSchema: Schema<Settings> }) {
  return {
    createAuthClient(clientConfig: AuthClientConfig) {
      return createBaseAuthClient({
        ...clientConfig,
        userSettingsSchema: config.userSettingsSchema,
      })
    },
  }
}

export type AuthBindingsUser<Settings extends Record<string, unknown>> =
  UserWithSettings<Settings>
